import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mode, QuestionType } from '../../app.constant';
import { CommonService } from '../../service/common.service';

declare var $;

@Component({
  selector: 'app-b-labeltext1',
  templateUrl: './b-labeltext1.component.html',
  styleUrls: ['./b-labeltext1.component.css']
})
export class BLabelText1Component implements OnInit {
  @Input() base: any;

  @Input() question: any;
  @Input() t_result_list: any[];
  @Input() mode: number;
  @Output() t_result_listChange = new EventEmitter();

  @Input() isEnable: boolean;

  inputText;
  required_flg: boolean;

  MODE: any = Mode;
  Q_TYPE:any = QuestionType;

  regex;
  
  constructor(
    private commonService: CommonService
  ) { }

ngOnInit() {
  this.required_flg = this.commonService.exchange01toTF(this.question.m_question_required_flg);
  this.question.t_result_list.error_msg  ="";

  if (this.question.m_answer_type_id==2){
    this.regex = new RegExp(/^[0-9]+$/);
  }else{
    this.regex = new RegExp(/.+/);
  }
  };

  onBlurMethod(): void {
    this.question.t_result_list.error_msg  ="";
    if(!this.checkNumberFormat(this.question.t_result_list.t_result_answer_str) && this.question.m_answer_type_id==2)
    {
      this.question.t_result_list.error_msg = "Only Numbers.";
    }
  }
//数字かどうかの入力チェック
checkNumberFormat(values:any){
  if (values==null || values==''){
    return true;
  }else{
    //値が数値だけか
    var regex = new RegExp(/^[0-9]+$/);
    return regex.test(values);
  }
}
}



// WEBPACK FOOTER //
// ./src/app/parts/b-labeltext1/b-labeltext1.component.ts